import { render } from "./TaskGrid.vue?vue&type=template&id=0c836192&scoped=true"
import script from "./TaskGrid.vue?vue&type=script&lang=js"
export * from "./TaskGrid.vue?vue&type=script&lang=js"

import "./TaskGrid.vue?vue&type=style&index=0&id=0c836192&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c836192"]])

export default __exports__